/*
电站运行看板-订单数据
 */
import React, { Component } from "react";
import "@/assets/stylus/data_analysis.styl";
import PropTypes from "prop-types";
import "@ant-design/compatible/assets/index.css";
import { Affix, Tooltip, Modal } from "antd";
import FormCore from "@/components/display/form/formCore";
import CityDataFilterHoc from "@/hoc/form/cityDataHoc";
import moment from "moment";
// 业务接口
import { RightOutlined, QuestionCircleFilled, QuestionCircleOutlined } from "@ant-design/icons";
import OrderTotalModal from "../../configurationManagement/stub/orderTotalModal";
import { connect } from "react-redux";
import "@/assets/stylus/displayBoard.styl";
import icon1 from "@/assets/img/displayBoard/电站.png";
import icon2 from "@/assets/img/displayBoard/终端总数.png";
import icon3 from "@/assets/img/displayBoard/交流.png";
import icon4 from "@/assets/img/displayBoard/额定功率.png";
import icon5 from "@/assets/img/displayBoard/直流.png";
import { injectIntl } from "react-intl";
import OrderErrorType from "./orderErrorType";
import OrderNumType from "./orderNumType";
import Top20FaultRate from "./top20FaultRate";

import {
  getCityList,
  // queryOrderNewCountQry,
  queryKanbanOrderNewCountQry,
  getChanelRankList,
  queryOrderAreaNumQry,
  userManagerRegionList,
  getStopReason,
} from "../../../fetch/fetchApi";
import fetchHandler from "../../../fetch/fetchHandler";
import "./index.styl";

// 国际化切换语言

const SORT_TYPE_OPTIONS = [
  // value替换为对应字段
  { name: "订单总数", value: "0" },
  { name: "成功订单数", value: "1" },
  { name: "失败订单数", value: "2" },
  { name: "成功率", value: "3" },
];

const SORT_ORDER_OPTIONS = [
  { name: "从高到低", value: "-1" },
  { name: "从低到高", value: "1" },
];

@CityDataFilterHoc
@connect((state) => state)
class OrderDisplayBoard extends Component {
  constructor(props) {
    super(props);
    this.props = props;
    this.internationalization = this.props.intl.messages.chargSuccess;

    this.props = props;
    this.state = {
      areaList: [
        {
          text: "全部",
          value: "",
        },
      ],
      equipmentQry: {
        station: 1,
        stub: 1,
        powerBox: 2,
      },
      totalOrderNum: 0,
      errorNum: 0,
      normalNum: 0,
      appkey: null,

      endDate: moment(new Date()).subtract(0, "d"),
      formConfig: null,
      appKeyList: [],
      param: {
        cityIds: "",
        provinceIds: "000000", // 默认 000000全国
        date: "",
        operationProperty: "3",
        areaIds: "",
        chooseDate: [moment(new Date()).subtract(7, "d"), moment(new Date()).subtract(1, "d")], // 选择的日期
        startTime: moment(new Date()).subtract(7, "d").format("YYYY-MM-DD"),
        endTime: moment(new Date()).subtract(1, "d").format("YYYY-MM-DD"),
      },
      typeOption: [
        {
          text: "全部",
          value: "",
        },
      ],
      hiddenDateS: 1,
      timeType: "pickDate", // 查询form表单 日期表单选择方式  pickMonth：年月选择； pickDate：年月日选择
      monthDataList: [], // 异常分类占比
      dailyDataList: [], // 按日呈现数据源
      firmwareDataList: [], // 固件版本数据源
      stopReasonDataList: [], // 停止原因数据源
    };
  }

  componentWillMount() {
    this.setState({
      formConfig: this.initFormConfig(),
    });
    //获取渠道key
    fetchHandler(getChanelRankList, {}).then((res) => {
      if (res && res.code === "success") {
        var options = [];
        for (var key in res.data) {
          options.push({ text: res.data[key], value: key });
        }
        console.info(options);
        this.setState({
          appKeyList: options,
        });
        this.setState({
          formConfig: this.initFormConfig(),
        });
        this.initSource();
      }
    });

    this.getAreaList();
    this.getCityList();
  }

  static contextTypes = {
    store: PropTypes.object.isRequired,
  };

  initFormConfig() {
    this.setState({
      isSearch: 1,
    });
    const formConfig = {
      childItems: [
        {
          type: "select",
          placeholder: "请选择", // '请选择设备状态',
          labelName: "运营类型", // '设备状态',
          param: {
            name: "operationMode",
            type: "string",
          },
          options: [
            {
              text: "全部",
              value: "",
            },
            {
              text: "非直营",
              value: "0",
            },
            {
              text: "直营",
              value: "1",
            },
          ],
          required: false,
          defaultValue: "",
        },
        {
          type: "select",
          options: [
            {
              text: this.internationalization.all, // '全部',
              value: "",
            },
            {
              text: this.internationalization.type1, // '交流',
              value: "0",
            },
            {
              text: this.internationalization.type2, // '直流',
              value: "1",
            },
            {
              text: "交直流", // '交直流',
              value: "2",
            },
          ],
          placeholder: "请选择设备类型",
          param: {
            name: "stubType",
            type: "string",
          },
          labelName: this.internationalization.title4, // '设备类型:',
          required: false,
          defaultValue: "",
        },
        {
          type: "select",
          placeholder: "请选择", // '请选择大区',
          labelName: "大区", // '大区',
          param: {
            name: "areaIds",
            type: "string",
          },
          options: this.state.areaList,
          allowClear: true,
          required: false,
          onChange: async (value, form) => {
            if (value == null || value == "") {
              //恢复区域信息
              form.setFieldsValue({
                cityGroup: [],
              });
            } else {
              //遍历区域，把不属于
              form.setFieldsValue({
                cityGroup: value.split(","),
              });
            }
            this.setState({
              formConfig: this.initFormConfig(value),
            });
          },
        },
        {
          type: "select",
          options: [
            {
              text: this.internationalization.all, // '全部',
              value: "",
            },
            {
              text: "A类", // '交流',
              value: "1",
            },
            {
              text: "B类", // '直流',
              value: "2",
            },
            {
              text: "C类", // '交直流',
              value: "3",
            },
          ],
          placeholder: "请选择城市类别",
          param: {
            name: "infoType",
            type: "string",
          },
          labelName: "城市类别", // '城市类别:',
          required: false,
          defaultValue: "",
        },
        {
          type: "treeSelect",
          placeholder: "请选择地区",
          param: {
            name: "cityGroup",
            type: "array",
          },
          onChange: this.changeCityData,
          data: this.state.quanguoCityArry,
          treeCheckable: true,
          treeCheckStrictly: false,
          showCheckedStrategy: "SHOW_PARENT",
          labelName: "地区",
          required: false,
        },

        {
          type: "select",
          selectType: "multiple", // 可用于替代checkbox
          placeholder: "请选择",
          filterOption: "value",
          param: {
            name: "projectNames",
            type: "array",
          },
          required: !1,
          labelName: "应用渠道分类",
          options: this.state.appKeyList,
        },
        {
          type: "date",
          dateType: "rangeDate",
          placeholder: ["开始时间", "结束时间"],
          param: {
            name: "chooseDate",
            type: "array",
          },
          width: "200px",
          allowClear: false,
          defaultValue:
            !this.state.param.chooseDate || this.state.param.chooseDate === null
              ? [moment(new Date()).subtract(7, "d"), moment(new Date()).subtract(1, "d")]
              : [moment(this.state.param.chooseDate[0]), moment(this.state.param.chooseDate[1])],
          validator: {
            // 日期自定义校验规则
            vtype: "date", // 校验名称
            min_val: 0, // 可选最小天数
            max_val: 31, // 最大可选天数
          }, // 自定义校验规则
          labelName: "日期", // '订单结束时间:',
          required: !1,
        },
        {
          type: "buttonGp", // 表单最终执行组
          buttonArr: [
            {
              btnType: "button",
              text: "查询",
              // icon: "search",
              handler: (e, param) => {
                console.info("群里");
                console.info(param);
                // 设置城市数组
                let cityIds = "";
                var infoType = param.infoType; //城市类别
                // 判断选择地区类型（全国、省份、城市）
                let cityType = "0"; // 0：全国，1：省份，2：城市
                if (param.cityGroup !== undefined) {
                  if (param.cityGroup.length === 0) {
                    console.info("问问3");
                    // cityIds = "000000";
                    var ids = [];
                    cityType = "2";
                    //省份下的城市 cityIds改成所选省份下的城市
                    this.state.quanguoCityArry[0].children.forEach(function (item) {
                      item.children.forEach(function (one) {
                        if (infoType && infoType != null) {
                          if (one.cityType == infoType) {
                            ids.push(one.key);
                          }
                        } else {
                          ids.push(one.key);
                        }
                      });
                    });
                    cityIds = ids.join(",");
                  } else if (param.cityGroup[0] === "000000") {
                    console.info("问问4");
                    // cityType = "0";
                    var ids = [];
                    cityType = "2";
                    //省份下的城市 cityIds改成所选省份下的城市
                    this.state.quanguoCityArry[0].children.forEach(function (item) {
                      item.children.forEach(function (one) {
                        if (infoType && infoType != null) {
                          if (one.cityType == infoType) {
                            ids.push(one.key);
                          }
                        } else {
                          ids.push(one.key);
                        }
                      });
                    });
                    cityIds = ids.join(",");
                  } else if (
                    param.cityGroup[0].charAt(5) === "0" &&
                    param.cityGroup[0].charAt(4) === "0" &&
                    param.cityGroup[0].charAt(3) === "0" &&
                    param.cityGroup[0].charAt(2) === "0"
                  ) {
                    console.info("问问5");
                    var ids = [];
                    cityType = "2";
                    //省份下的城市 cityIds改成所选省份下的城市
                    this.state.quanguoCityArry[0].children.forEach(function (item) {
                      if (param.cityGroup.indexOf(item.key) != -1) {
                        item.children.forEach(function (one) {
                          if (infoType && infoType != null) {
                            if (one.cityType == infoType) {
                              ids.push(one.key);
                            }
                          } else {
                            ids.push(one.key);
                          }
                        });
                        item.children.forEach(function (one) {});
                      }
                    });
                    cityIds = ids.join(",");
                  } else {
                    console.info("问问6" + cityIds);
                    cityType = "2";
                    this.state.quanguoCityArry[0].children.forEach(function (item) {
                      item.children.forEach(function (one) {
                        if (param.cityGroup.indexOf(one.key) != -1) {
                          if (infoType && infoType != null) {
                            if (one.cityType == infoType) {
                              cityIds += `${one.key},`;
                            }
                          } else {
                            cityIds += `${one.key},`;
                          }
                        }
                      });
                    });
                  }
                } else {
                  console.info("问问7");
                  var ids = [];
                  cityType = "2";
                  //省份下的城市 cityIds改成所选省份下的城市
                  this.state.quanguoCityArry[0].children.forEach(function (item) {
                    item.children.forEach(function (one) {
                      if (infoType && infoType != null) {
                        if (one.cityType == infoType) {
                          ids.push(one.key);
                        }
                      } else {
                        ids.push(one.key);
                      }
                    });
                  });
                  cityIds = ids.join(",");
                }
                var startTime = null;
                var endTime = null;
                if (
                  param.chooseDate != null &&
                  param.chooseDate != "" &&
                  param.chooseDate.length > 0
                ) {
                  startTime = param.chooseDate.split(",")[0];
                  endTime = param.chooseDate.split(",")[1];
                }
                this.setState(
                  {
                    param: {
                      cityIds: cityType === "2" ? cityIds || "" : "",
                      provinceIds: cityType === "0" || cityType === "1" ? cityIds || "000000" : "",
                      stubType: param.stubType,
                      operationMode: param.operationMode,
                      projectNames:
                        param.projectNames &&
                        param.projectNames != null &&
                        param.projectNames.length > 0
                          ? param.projectNames.join(",")
                          : null,
                      operationProperty: "3",
                      userId: param.userId,
                      infoType: param.infoType,
                      companyId: param.companyId,
                      startTime: startTime,
                      endTime: endTime,
                    },
                  },
                  () => {
                    // 查询订单累计数据
                    this.handleGetMonthData();
                  },
                );
              },
            },
          ],
        },
      ],
      defaultValue: {
        operationProperty: "3",
      },
      layout: "inline", // 设置布局 0： 横向布局， 1：纵向布局
      formTarget: "grid", // 表单提交类型，设置grid则为更新grid
      autoLoadGrid: !1, // 设置为false不触发加载grid
      context: this,
      tableKey: "taskTable",
    };

    return formConfig;
  }

  initSource = () => {
    this.handleGetMonthData();
  };

  compare = (property) => {
    return function (obj1, obj2) {
      var value1 = obj1[property];
      var value2 = obj2[property];
      return value2 - value1; // 升序
    };
  };

  setLoading = (key, val) => {
    this.setState({
      [`${key}Loading`]: val,
    });
  };

  getFormatter = () => {
    return this.state.timeType === "pickMonth" ? "YYYYMM" : "YYYYMMDD";
  };

  // 获取累计数据
  handleGetMonthData = () => {
    if (
      this.state.param.infoType != null &&
      (this.state.param.cityIds == null || this.state.param.cityIds == "") &&
      (this.state.param.provinceIds == null || this.state.param.provinceIds == "")
    ) {
      this.setState({
        monthDataList: [],
        totalOrderNum: 0,
        errorNum: 0,
        normalNum: 0,
        errorNumRate: 0,
        normalNumRate: 0,
      });
      return;
    }
    this.setLoading("month", true);
    console.info("数据：");
    console.info(this.state);
    fetchHandler(queryKanbanOrderNewCountQry, {
      userId: this.state.param.userId,
      companyId: this.state.param.companyId,
      operationMode: this.state.param.operationMode,
      stubType: this.state.param.stubType,
      cityIds: this.state.param.cityIds,
      appKey: this.state.param.projectNames,
      provinceIds: this.state.param.provinceIds,
      startTime: this.state.param.startTime,
      endTime: this.state.param.endTime,
    }).then((res) => {
      if (res.data) {
        var totalOrderNum = 0;
        var normalNum = 0;
        var errorNum = 0;
        var normalNumRate = 0;
        var errorNumRate = 0;
        if (res.data.statusList && res.data.statusList.length > 0) {
          res.data.statusList.forEach(function (item) {
            totalOrderNum += item.num;
            if (item.status == 2) {
              errorNum = item.num;
            } else {
              normalNum = item.num;
            }
          });
        }
        normalNumRate = normalNum == 0 ? 0 : ((normalNum / totalOrderNum) * 100).toFixed(2);
        errorNumRate = errorNum == 0 ? 0 : (100 - parseFloat(normalNumRate)).toFixed(2);
        var monthDataList = [];
        var firmwareDataList = [];
        var totalErrorNum = 0;
        var index = 1; //
        var otehrRate = 0;
        // var nearMap = new Map();
        if (res.data.dayList && res.data.dayList != null && res.data.dayList.length > 0) {
          // //将同一天的正常异常数据合并，然后计算正确率
          // res.data.dayList.forEach((val) => {
          //   if (!nearMap.get(val.day_info) || nearMap.get(val.day_info) == null) {
          //     var one = {};
          //     one.day_info = val.day_info;
          //     if (val.status == 2) {
          //       one.error_num = val.order_num;
          //       one.success_num = 0;
          //       one.total_num = one.error_num;
          //       one.rate = 0;
          //     } else {
          //       one.error_num = 0;
          //       one.success_num = val.order_num;
          //       one.total_num = one.success_num;
          //       one.rate = 100;
          //     }
          //     nearMap.set(val.day_info, one);
          //   } else {
          //     var one = nearMap.get(val.day_info);
          //     if (val.status == 2) {
          //       one.error_num += val.order_num;
          //       one.rate =
          //         one.success_num == 0
          //           ? 0
          //           : ((one.success_num / (one.success_num + one.error_num)) * 100).toFixed(2);
          //       one.total_num = one.success_num + one.error_num;
          //     } else {
          //       one.success_num += val.order_num;
          //       one.rate =
          //         one.success_num == 0
          //           ? 0
          //           : ((one.success_num / (one.success_num + one.error_num)) * 100).toFixed(2);
          //       one.total_num = one.success_num + one.error_num;
          //     }
          //     nearMap.set(val.day_info, one);
          //   }
          // });
          firmwareDataList = res.data.dayList;
        }
        // console.info(nearMap);
        // nearMap.forEach((val, key) => {
        //   console.info(val);
        //   firmwareDataList.push(val);
        // });
        if (res.data.errorCount && res.data.errorCount != null && res.data.errorCount.length > 0) {
          // var newArr = res.data.errorCount.sort(this.compare("total_num"));
          // const map = new Map(Object.entries(newArr));
          // map.forEach((val, key) => {
          //   if (val.status == null || val.status == 2) {
          //     totalErrorNum += val.total_num;
          //     var one = {
          //       failureOrder: val.total_num,
          //       date: val.end_info ? val.end_info : val.end_code,
          //       end_code: val.end_code,
          //     };
          //     monthDataList.push(one);
          //   }
          // });
          // monthDataList.forEach((val, key) => {
          //   val.totalOrder = totalErrorNum;
          //   if (monthDataList.length == index) {
          //     if (val.failureOrder == 0) {
          //       val.successRate = 0;
          //     } else {
          //       val.successRate = ((1 - otehrRate) * 100).toFixed(2);
          //     }
          //   } else {
          //     if (val.failureOrder == 0) {
          //       val.successRate = 0;
          //     } else {
          //       val.successRate = ((val.failureOrder / totalErrorNum) * 100).toFixed(2);
          //     }
          //     otehrRate += parseFloat(val.successRate);
          //   }
          // });
          monthDataList = res.data.errorCount;
        }
        localStorage.setItem("errorMonthDataList", JSON.stringify(monthDataList));
        this.setState({
          monthDataList: monthDataList,
          firmwareDataList: firmwareDataList, //firmwareDataList.reverse(),
          totalOrderNum: totalOrderNum,
          errorNum: errorNum,
          normalNum: normalNum,
          errorNumRate: errorNumRate,
          normalNumRate: normalNumRate,
        });
      }
      this.setLoading("month", false);
    });
  };

  changeCityData = (value) => {
    if (value.length === 0) {
      // 设置数据
      this.setState(
        {
          quanguoCityArry: [...this.quanguoCityArry],
        },
        () => {
          this.setState({
            formConfig: this.initFormConfig(),
          });
        },
      );
    }
    if (value.length === 1) {
      let quanguoCityArryCVal = "";
      if (value[0] === "000000") {
        quanguoCityArryCVal = this.quanguoCityNotChild;
      } else if (
        value[0].charAt(5) === "0" &&
        value[0].charAt(4) === "0" &&
        value[0].charAt(3) === "0" &&
        value[0].charAt(2) === "0"
      ) {
        quanguoCityArryCVal = this.quanguoCityNotCity;
      } else {
        quanguoCityArryCVal = this.quanguoCityNotP;
      }
      // 设置数据
      this.setState(
        {
          quanguoCityArry: quanguoCityArryCVal,
        },
        () => {
          this.setState({
            formConfig: this.initFormConfig(),
          });
        },
      );
    }
  };
  /**
   * 获取城市数据
   */
  getCityList = () => {
    fetchHandler(getCityList, { cityType: 1, userId: sessionStorage.getItem("userId") }).then(
      (res) => {
        if (!res.data) {
          return;
        }
        const fetchPickerOptions = res.data;
        let formatOptionsStr = JSON.stringify(fetchPickerOptions);
        formatOptionsStr = formatOptionsStr.replace(new RegExp("label", "g"), "title");
        formatOptionsStr = formatOptionsStr.replace(new RegExp("value", "g"), "value");
        formatOptionsStr = formatOptionsStr.replace(new RegExp("children", "g"), "children");
        const cityAryy = JSON.parse(formatOptionsStr);
        cityAryy.map((item) => {
          item.key = item.value;
          item.children.map((item2) => {
            item2.key = item2.value;
            delete item2.children; // 删除子区域数据
            return true;
          });
          return true;
        });
        // 初始化城市数据
        this.quanguoCityArry = [
          {
            title: "全国",
            value: "000000",
            key: "000000",
            children: JSON.parse(JSON.stringify(cityAryy)),
          },
        ];

        // 只能选择城市的方式
        this.quanguoCityNotP = [
          {
            title: "全国",
            value: "000000",
            key: "000000",
            children: JSON.parse(JSON.stringify(cityAryy)),
          },
        ];
        this.quanguoCityNotP.map((item) => {
          item.disabled = true;
          item.children.map((item1) => {
            item1.disabled = true;
            item1.children.map((item2) => {
              item2.disabled = false;
              return true;
            });
            return true;
          });
          return true;
        });
        // 只能选择省份的数组
        this.quanguoCityNotCity = [
          {
            title: "全国",
            value: "000000",
            key: "000000",
            children: JSON.parse(JSON.stringify(cityAryy)),
          },
        ];
        this.quanguoCityNotCity.map((item) => {
          item.disabled = true;
          item.children.map((item1) => {
            item1.disabled = false;
            item1.children.map((item2) => {
              item2.disabled = true;
              return true;
            });
            return true;
          });
          return true;
        });
        // 只能选择全国的数组
        this.quanguoCityNotChild = [
          {
            title: "全国",
            value: "000000",
            key: "000000",
            children: JSON.parse(JSON.stringify(cityAryy)),
          },
        ];
        this.quanguoCityNotChild.map((item) => {
          item.disabled = false;
          item.children.map((item1) => {
            item1.disabled = true;
            item1.children.map((item2) => {
              item2.disabled = true;
              return true;
            });
            return true;
          });
          return true;
        });
        // 设置数据
        this.setState(
          {
            quanguoCityArry: [...this.quanguoCityArry],
          },
          () => {
            this.setState({
              formConfig: this.initFormConfig(),
            });
          },
        );
      },
    );
  };

  /**
   * 获取负责的大区列表
   */
  getAreaList() {
    let that = this;
    fetchHandler(userManagerRegionList, {
      userId: sessionStorage.getItem("userId"),
    }).then((res) => {
      if (res.data) {
        res.data.forEach(function (item) {
          item.text = item.regName;
          item.value = item.areaId;
        });
        res.data.unshift({
          text: "全部",
          value: "",
        });
        this.setState(
          {
            areaList: res.data,
          },
          () => {
            this.setState({
              formConfig: this.initFormConfig(),
            });
          },
        );
      }
    });
  }

  //type:1:全部订单，2：故障的，3：正常的
  getModalData(type) {
    if (
      this.state.param.infoType != null &&
      (this.state.param.cityIds == null || this.state.param.cityIds == "") &&
      (this.state.param.provinceIds == null || this.state.param.provinceIds == "")
    ) {
      return;
    }
    fetchHandler(queryOrderAreaNumQry, {
      type: type,
      userId: this.state.param.userId,
      companyId: this.state.param.companyId,
      operationMode: this.state.param.operationMode,
      stubType: this.state.param.stubType,
      cityIds: this.state.param.cityIds,
      appKey: this.state.param.projectNames,
      provinceIds: this.state.param.provinceIds,
      startTime: this.state.param.startTime,
      endTime: this.state.param.endTime,
    }).then((res) => {
      if (res.data) {
        var list = [];
        var fAreaId = null;
        var index = 0;
        if (res.data.areaNums && res.data.areaNums.length > 0) {
          res.data.areaNums.forEach(function (item) {
            var one = {};
            one.id = item.id;
            one.text = item.name;
            one.num = item.stationNum;
            if (index == 0) {
              fAreaId = item.id;
              one.choosed = 2;
            } else {
              one.choosed = 1;
            }
            index++;
            list.push(one);
          });
        }
        this.setState(
          {
            areaDTOList: list,
            fAreaId: fAreaId,
            modalType: type,
            modalTitle: type == 1 ? "累计订单数" : type == 2 ? "累计异常订单数" : "累计成功订单数",
            modalStationNum: res.data.stationNum,
            modalStationTitle: list.length > 0 ? list[0].text : "",
          },
          () => {
            this.setState({
              areaDTOList: list,
              fAreaId: fAreaId,
              modalTitle:
                type == 1 ? "累计订单数" : type == 2 ? "累计异常订单数" : "累计成功订单数",
              modalType: type,
              modalStationNum: res.data.stationNum,
              modalStationTitle: list.length > 0 ? list[0].text : "",
            });
            this.modalVisibleAction("statusLogVisible", true);
          },
        );
      }
    });
  }

  modalVisibleAction(modalVisibleKey, visible) {
    this.setState({
      [modalVisibleKey]: visible,
    });
  }

  // 点击柱状图选择月份
  mcSetDate = async (date) => {
    await this.setState({
      chooseDate: date,
      endDate: date,
      timeType: "pickMonth",
    });
    // 重新加载数据
    // this.top100EquRef.handleGetDataSource();
    // this.top10StationRef.handleGetDataSource();
    // this.top50ChanelRef.handleGetDataSource();
  };

  // 点击柱状图选择日期
  dcSetDate = async (date) => {
    await this.setState({
      chooseDate: date,
      endDate: date,
      timeType: "pickDate",
    });
    this.handleGetFirmwareData();
    // this.top100EquRef.handleGetDataSource();
    // this.top10StationRef.handleGetDataSource();
    // this.top50ChanelRef.handleGetDataSource();
  };

  render() {
    const val = (
      <div
        className="analysis charge-success-rate-container"
        ref="chargSuccsessRate"
        style={{ height: "100%", overflowY: "auto", overflowX: "hidden" }}>
        {/* <Affix target={() => this.refs.chargSuccsessRate}> */}
        <div className="analysis-title">
          <FormCore formConfig={this.state.formConfig} />
        </div>
        {/* </Affix> */}
        <div className="page-panel">
          <div className="display-board">
            <div className="item" style={{ width: "100%" }}>
              <div className="inner" style={{ padding: "24px 2%" }}>
                <div
                  className="fixed-more"
                  onClick={() => {
                    this.getModalData(1);
                  }}>
                  {" "}
                  详情
                  <RightOutlined />
                </div>
                <div className="detail-info stub-info-board">
                  <div className="stub-info-item">
                    <div className="name">
                      累计订单数{" "}
                      <Tooltip
                        title={() => (
                          <span style={{ color: "#000" }}>
                            检索条件范围内新增的已完成充电订单数量
                          </span>
                        )}
                        color="#ffffff"
                        overlayClassName="white-tooltip">
                        <QuestionCircleFilled
                          style={{
                            color: "#D9D9D9",
                            marginLeft: "4px",
                            top: "1px",
                          }}
                        />
                      </Tooltip>
                    </div>
                    <div className="num">{this.state.totalOrderNum}</div>
                  </div>
                </div>
              </div>
              <div className="inner" style={{ padding: "24px 2%" }}>
                <div
                  className="fixed-more"
                  onClick={() => {
                    this.getModalData(3);
                  }}>
                  {" "}
                  详情
                  <RightOutlined />
                </div>
                <div className="detail-info stub-info-board">
                  <div className="stub-info-item">
                    <div className="name">
                      累计正常订单数
                      <Tooltip
                        title={() => (
                          <span style={{ color: "#000" }}>
                            检索条件范围内新增的已完成且正常停止充电订单数量（停止类型详见系统管理-停止原因）
                          </span>
                        )}
                        color="#ffffff"
                        overlayClassName="white-tooltip">
                        <QuestionCircleFilled
                          style={{
                            color: "#D9D9D9",
                            marginLeft: "4px",
                            top: "1px",
                          }}
                        />
                      </Tooltip>
                    </div>
                    <div
                      className="num"
                      style={{ display: "flex", justifyContent: "space-between" }}>
                      <div>{this.state.normalNum}</div>
                      <div style={{ fontSize: "14px", color: "#a9a1a1" }}>
                        {this.state.normalNumRate}%
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="inner" style={{ padding: "24px 2%" }}>
                <div
                  className="fixed-more"
                  onClick={() => {
                    this.getModalData(2);
                  }}>
                  {" "}
                  详情
                  <RightOutlined />
                </div>
                <div className="detail-info stub-info-board">
                  <div className="stub-info-item">
                    <div className="name">
                      累计故障订单数
                      <Tooltip
                        title={() => (
                          <span style={{ color: "#000" }}>
                            检索条件范围内新增的已完成且异常停止充电订单数量（停止类型详见系统管理-停止原因）
                          </span>
                        )}
                        color="#ffffff"
                        overlayClassName="white-tooltip">
                        <QuestionCircleFilled
                          style={{
                            color: "#D9D9D9",
                            marginLeft: "4px",
                            top: "1px",
                          }}
                        />
                      </Tooltip>
                    </div>
                    <div
                      className="num"
                      style={{ display: "flex", justifyContent: "space-between" }}>
                      <div>{this.state.errorNum}</div>
                      <div style={{ fontSize: "14px", color: "#a9a1a1" }}>
                        {this.state.errorNumRate}%
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <OrderErrorType
          {...this.props}
          dataSource={this.state.monthDataList}
          areaListData={this.state.monthDataList}
          quanguoCityArryData={this.state.monthDataList}
          setChooseDate={this.mcSetDate}
          chooseDate={this.state.chooseDate}
          timeType={this.state.timeType}
          endDate={this.state.endDate}
          loading={this.state.monthLoading}
          modalParam={this.state.param}
        />
        <OrderNumType
          {...this.props}
          modalParam={this.state.param}
          dataSource={this.state.firmwareDataList}
          loading={this.state.monthLoading}
        />
        <Top20FaultRate
          {...this.props}
          modalParam={this.state.param}
          loading={this.state.monthLoading}
        />
        <Modal
          title={this.state.modalTitle}
          visible={this.state.statusLogVisible}
          footer={null}
          destroyOnClose
          width="800px"
          onCancel={() => {
            this.modalVisibleAction("statusLogVisible", false);
          }}>
          <OrderTotalModal
            modalParam={this.state.param}
            stubIdData={this.state.areaDTOList}
            modalType={this.state.modalType}
            firstId={this.state.fAreaId}
            modalStationTitle={this.state.modalStationTitle}
            modalStationNum={this.state.modalStationNum}
          />
        </Modal>
      </div>
    );
    return val;
  }
}

export default injectIntl(OrderDisplayBoard);



// WEBPACK FOOTER //
// ./src/AntD/pages/indicatorReport/chargeSuccessRate/orderDisplayBoard.js